const normalizeStageId = stageId =>
  stageId === undefined || stageId === null ? '' : String(stageId);

const normalizeLabelTitle = labelTitle =>
  String(labelTitle || '')
    .trim()
    .toLocaleLowerCase();

const LABEL_STAGE_ACTIONS = new Set(['move', 'mark_won', 'mark_lost']);
const STAGE_LABEL_ACTIONS = new Set(['add', 'remove']);

export const areLabelStageMappingsValid = ({
  mappings = {},
  stages = [],
  labels = [],
}) => {
  const stageIds = new Set(stages.map(stage => normalizeStageId(stage.id)));
  const labelTitles = new Set(
    labels.map(label => normalizeLabelTitle(label.title)).filter(Boolean)
  );

  const labelStageMappings = Array.isArray(mappings.label_stage_mappings)
    ? mappings.label_stage_mappings
    : [];
  const stageLabelMappings = Array.isArray(mappings.stage_label_mappings)
    ? mappings.stage_label_mappings
    : [];

  const labelStageMappingsAreValid = labelStageMappings.every(mapping => {
    const labelIsValid = labelTitles.has(
      normalizeLabelTitle(mapping.label_title)
    );
    if (!labelIsValid || !LABEL_STAGE_ACTIONS.has(mapping.action)) return false;
    if (mapping.action !== 'move') return true;
    return stageIds.has(normalizeStageId(mapping.target_stage));
  });

  const stageLabelMappingsAreValid = stageLabelMappings.every(mapping =>
    Boolean(
      stageIds.has(normalizeStageId(mapping.stage)) &&
        labelTitles.has(normalizeLabelTitle(mapping.label_title)) &&
        STAGE_LABEL_ACTIONS.has(mapping.action)
    )
  );

  return labelStageMappingsAreValid && stageLabelMappingsAreValid;
};

export default areLabelStageMappingsValid;
